import { useMemo } from 'react';
import useWindowDimensions from './use-window-dimensions';

function useCloudinary() {
  const { width } = useWindowDimensions();
  // const screenWitdh = useMemo(() => window.innerWidth, []);

  const parsedWitdh = useMemo(
    // eslint-disable-next-line no-undef
    () => width * (window.devicePixelRatio > 2 ? 2 : 1),
    [width]
  );

  function getBreakpoint(divider) {
    const screenWitdh = parsedWitdh / divider;
    const breakpoints = [100, 320, 540, 1080, 1620];
    const breakpoint = breakpoints
      .filter((bp) => bp >= screenWitdh)
      ?.find(() => true);

    return breakpoint != null ? `/w_${breakpoint},c_scale,f_auto` : '/';
  }

  function transform(url, divider = 1) {
    const regex = /^(http.:\/\/.+cloudinary.com\/.+\/image\/upload)(\/.+)$/gi;
    const match = regex.exec(url);

    if (match == null) return url;

    return `${match[1]}${getBreakpoint(divider)}${match[2]}`;
  }

  return { transform };
}

export { useCloudinary };
